export enum CategoryType {
  Query = 1,
  Topic = 2,
  Uncategorized = 3,
}
